
// import { motion } from 'framer-motion' - unused

import { GlassCard } from '../ui/GlassCard'

const timeline = [
    {
        year: "2024",
        title: "The Autonomous Shift",
        company: "Lehana.in",
        description: "Pivoted focus to fully autonomous systems and Agentic AI. Architected the MCP Gateway and multi-agent health monitoring pipelines."
    },
    {
        year: "2022",
        title: "Full Stack Architect",
        company: "Aidhunik Tech",
        description: "Led the migration to microservices and Docker-first architecture. Developed the core scraping engine used by multi-million dollar data pipelines."
    },
    {
        year: "2020",
        title: "Lead Frontend Engineer",
        company: "Digital Innovations",
        description: "Specialized in high-performance React applications and cinematic UIs. Won 'Design of the Year' for internal dashboards."
    },
    {
        year: "2018",
        title: "Software Engineer",
        company: "CodeBase Solutions",
        description: "Started the journey into large-scale systems. Mastered the fundamentals of distributed computing and clean code."
    }
]

export const Timeline = () => {
    return (
        <section className="py-20 px-4 max-w-5xl mx-auto relative">

            {/* Center Line */}
            <div className="absolute left-1/2 top-0 bottom-0 w-[1px] bg-gradient-to-b from-transparent via-primary/30 to-transparent hidden md:block" />

            <div className="mb-16 text-center">
                <h2 className="text-4xl font-bold mb-4">The <span className="text-primary">Journey</span></h2>
                <p className="text-secondary-foreground">A timeline of technical evolution and impact.</p>
            </div>

            <div className="space-y-12">
                {timeline.map((item, i) => (
                    <div key={i} className={`flex flex-col md:flex-row items-center gap-8 ${i % 2 === 0 ? 'md:flex-row-reverse' : ''}`}>

                        {/* Content */}
                        <div className="flex-1 w-full">
                            <GlassCard
                                variant="hover"
                                className={`text-left border-white/5 ${i % 2 === 0 ? 'md:text-right' : ''}`}
                            >
                                <span className="text-primary font-black text-2xl mb-2 block">{item.year}</span>
                                <h3 className="text-xl font-bold mb-1">{item.title}</h3>
                                <p className="text-secondary-foreground text-sm font-medium mb-3">{item.company}</p>
                                <p className="text-secondary-foreground text-sm leading-relaxed">
                                    {item.description}
                                </p>
                            </GlassCard>
                        </div>

                        {/* Dot */}
                        <div className="relative z-10">
                            <div className="h-4 w-4 rounded-full bg-primary shadow-[0_0_15px_rgba(59,130,246,0.8)] border-4 border-background" />
                        </div>

                        {/* Spacer for alignment */}
                        <div className="flex-1 hidden md:block" />
                    </div>
                ))}
            </div>
        </section>
    )
}
